<div class="relative">
  @if (personalInfoIsLoading) {
    <korviu-loader></korviu-loader>
  }
  <div class="card mb-6 md:mb-8 relative w-full flex flex-col lg:flex-row p-4 md:py-6 md:px-10 gap-6 lg:items-center">
    <div>
      <div class="size-[10.5rem] md:size-[12.5rem] mx-auto relative">
        <app-user-avatar-v2 [user]="user" [avatarUrl]="selectedAvatar()?.imageUrl" />
      </div>
      @if (!isSpecial) {
        <div class="flex flex-col items-center justify-center mb-4 mt-6 lg:mb-2 w-full">
          <span class="text-[#2C3035] text-[2.3125rem] font-bold">{{ user.firstName }}</span>
          <span class="text-[#2C3035] text-[1.125rem] text-[#505760]"
            >{{ 'profile.level' | translate }}: <span class="text-[#078339]">{{ levelName | translate }}</span>
          </span>
        </div>
      }
    </div>
    <korviu-scrollbar class="w-full">
      <div>
        @if (!!avatarsIsLoading) {
          <korviu-loader></korviu-loader>
        } @else {
          <div
            class="avatar-options grid gap-2 md:gap-3 relative"
            [class.avatar-options--special]="isSpecial"
            role="group"
            [attr.aria-label]="'profile.chooseTree' | translate"
          >
            @for (avatar of avatars(); track avatar.id) {
              @if (avatar.level === 6 || !isSpecial) {
                @let disabled = isAvatarDisabled(avatar);
                <button
                  type="button"
                  class="avatar-option"
                  [class.avatar-option--selected]="avatar.id === selectedAvatarId()"
                  [disabled]="disabled"
                  [attr.aria-pressed]="avatar.id === selectedAvatarId()"
                  [attr.aria-label]="'profile.treeOption' | translate: { type: avatar.treeType, level: avatar.level }"
                  [title]="
                    disabled
                      ? ('profile.treeUnlocksAtLevel' | translate: { level: avatar.level })
                      : ('profile.treeOption' | translate: { type: avatar.treeType, level: avatar.level })
                  "
                  (click)="onSelectAvatar(avatar.id, disabled)"
                >
                  @if (avatar.id === selectedAvatarId()) {
                    <i class="avatar-option-check" aria-hidden="true">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                        <path
                          d="M16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08167 16 0.5 12.4183 0.5 8C0.5 3.58172 4.08167 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8ZM13.378 4.57665C13.0939 4.29263 12.6334 4.29263 12.3493 4.57665L7.04545 9.88057L4.65069 7.48575C4.36662 7.20172 3.90611 7.20172 3.62204 7.48575C3.33811 7.76976 3.33811 8.23024 3.62204 8.51426L6.53113 11.4233C6.8152 11.7074 7.27571 11.7074 7.55978 11.4233L13.378 5.60516C13.6619 5.32115 13.6619 4.86067 13.378 4.57665Z"
                          fill="#0D9443"
                        />
                      </svg>
                    </i>
                  }
                  <img [src]="avatar.imageUrl" class="size-full object-cover rounded-full" alt="" loading="lazy" />
                </button>
              }
            }
          </div>
        }
      </div>
    </korviu-scrollbar>
  </div>
  <div class="w-full flex flex-col gap-4 gap-6">
    @if (user?.isSpecial) {
      <!-- Contract holder name -->
      <korviu-input
        class="flex-1"
        type="text"
        label="{{ 'profile.contractHolderName' | translate }}"
        [control]="contractHolderNameControl"
        [isReadOnly]="true"
        [disabled]="true"
        [showErrorMessagesUnderField]="true"
      />
      <!-- Contact name -->
      <korviu-input
        class="flex-1"
        type="text"
        label="{{ 'referral.contactName' | translate }}"
        [control]="contactPersonControl"
        [showErrorMessagesUnderField]="true"
      />
    } @else {
      <!-- FIRST NAME / LAST NAME -->

      <div class="flex gap-4 md:gap-8">
        <korviu-input
          class="flex-1"
          type="text"
          label="{{ 'auth.signup.firstName' | translate }}"
          [control]="firstNameControl"
          [showErrorMessagesUnderField]="true"
        />
        <korviu-input
          class="flex-1"
          type="text"
          label="{{ 'auth.signup.lastName' | translate }}"
          [control]="lastNameControl"
          [showErrorMessagesUnderField]="true"
        />
      </div>
    }

    <!-- PHONE NUMBER -->

    <korviu-input
      type="phone"
      label="{{ 'auth.signup.phoneNumber' | translate }}"
      maxLength="14"
      [control]="phoneNumberControl"
      [phoneNumberPrefixControl]="phoneNumberCountryIdControl"
      [showErrorMessagesUnderField]="true"
      [errorMessagesUnderField]="[
        { errorCode: 'pattern', localizedMessage: 'validation.invalidPhoneNumber' },
        { errorCode: 'minlength', localizedMessage: 'validation.invalidPhoneNumber' }
      ]"
    ></korviu-input>

    <!-- EMAIL -->

    <korviu-input
      type="text"
      label="{{ 'auth.signup.email' | translate }}"
      [control]="emailControl"
      [showErrorMessagesUnderField]="true"
      [errorMessagesUnderField]="[
        { errorCode: 'email', localizedMessage: 'validation.invalidEmail' },
        { errorCode: 'emailInUse', localizedMessage: 'validation.emailInUse' },
        { errorCode: 'domainNotAllowed', localizedMessage: 'validation.domainNotAllowed' }
      ]"
    ></korviu-input>

    <!-- COUNTRY AND STATE -->

    <div class="flex gap-4 md:gap-8">
      <div class="flex-1">
        <app-country-select [control]="countryControl"></app-country-select>
      </div>
      <div class="flex-1">
        @if (statesIsLoading) {
          <nz-spin class="min-h-10"></nz-spin>
        } @else {
          <korviu-select
            label="{{ 'auth.signup.state' | translate }}"
            [control]="stateControl"
            [options]="states"
            [disable]="!controlHasValue(countryControl)"
            [showErrorMessagesUnderField]="true"
          />
        }
      </div>
    </div>

    <!-- CITY AND ZIP CODE -->

    <div class="flex gap-4 md:gap-8">
      <korviu-input
        class="flex-1"
        type="text"
        label="{{ 'auth.signup.city' | translate }}"
        [control]="cityControl"
        [errorMessagesUnderField]="[{ errorCode: 'minlength', localizedMessage: 'validation.invalidCity' }]"
        [showErrorMessagesUnderField]="true"
      ></korviu-input>
      <korviu-input
        class="flex-1"
        type="text"
        label="{{ 'auth.signup.zipCode' | translate }}"
        maxLength="5"
        [onlyNumbers]="true"
        [control]="zipControl"
        [showErrorMessagesUnderField]="true"
      ></korviu-input>
    </div>

    <!-- BUTTONS -->

    <div class="flex gap-4 mt-12 sm:mt-12 lg:mt-16 w-full">
      <korviu-button class="flex-1" size="large" color="ghost" (click)="onUpdateInfoCancelClick()">
        {{ 'common.cancel' | translate }}
      </korviu-button>
      <korviu-button class="flex-1" size="large" color="tertiary" (click)="onUpdateInfoSaveClick()">
        {{ 'common.save' | translate }}
      </korviu-button>
    </div>
  </div>
</div>
